import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  addDays,
  isBefore,
  isWithinInterval,
  startOfDay,
  endOfDay,
  intervalToDuration,
  differenceInDays,
} from "date-fns";
import { db } from "../Services/Firebase";
// Não pode retornar remainingDays negativos.//
// Quando remainginDays for 0, isTrial e isSubscriber tem que ser false.

export default function useSubscription() {
  const userEmail = useSelector((state) => state?.user?.userData?.email);
  const accountCreatedAt = useSelector(
    (state) => state?.user?.userData?.createdAt
  );

  const [isLoaded, setIsLoaded] = useState(false);

  const [remainingDays, setRemainingDays] = useState(0);
  const [activeCycle, setActiveCycle] = useState(null);

  const isSubscriber = Boolean(activeCycle);

  const today = new Date();
  const limitTrial = addDays(accountCreatedAt, 15);
  const isTrial = isSubscriber ? false : isBefore(today, limitTrial);//TODO: Verificar se o usuário já está como assinante.

  async function getAllCyclesByEmail(email) {
    let cycles = [];
    const collection = await db
      .collection("cycles")
      .where("subscription_client_email", "==", email)
      .get();

    collection.forEach((doc) => {
      const cycle = doc.data();
      cycle.start = cycle.start.toDate();
      cycle.end = cycle.end.toDate();
      cycles.push(cycle);
    });
    return cycles;
  }

  function getActiveCycleByCycles(cycles) {
    return cycles.find((cycle) =>
      isWithinInterval(new Date(), {
        start: startOfDay(cycle.start),
        end: endOfDay(cycle.end),
      })
    );
  }

  function isActiveCycleByCycle(cycle) {
    return isWithinInterval(new Date(), {
      start: startOfDay(cycle.start),
      end: endOfDay(cycle.end),
    });
  }

  function getPendingCycles(cycles) {
    return cycles.filter((cycle) => isBefore(today, cycle.end));
  }

  function getRemainingDaysSubscription(cycles) {
    return getPendingCycles(cycles).reduce((acc, cycle) => {
      if (isActiveCycleByCycle(cycle))
        return acc + differenceInDays(cycle.end, today);
      return acc + differenceInDays(cycle.end, cycle.start);
    }, 0);
  }

  function getRemainingDaysTrial(cycles) {
    return intervalToDuration({ start: today, end: limitTrial }).days;
  }

  function getRemainingDays(cycles) {
    if (isTrial) return getRemainingDaysTrial(cycles);

    return getRemainingDaysSubscription(cycles);
  }

  useEffect(() => {
    if (!userEmail) return;

    getAllCyclesByEmail(userEmail).then((cycles) => {
      setActiveCycle(getActiveCycleByCycles(cycles));
      setRemainingDays(getRemainingDays(cycles));
      setIsLoaded(true);
    });
  }, [userEmail]);

  const response = {
    isLoaded,
    isTrial,
    isSubscriber,
    activeCycle: {
      ...activeCycle,
      start: activeCycle?.start.toLocaleDateString("pt-BR"),
      end: activeCycle?.end.toLocaleDateString("pt-BR"),
    },
    remainingDays,
  };
  return response;
}
